(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'uri-kmp-uri'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'uri-kmp-uri'.");
    }
    globalThis['uri-kmp-uri'] = factory(typeof globalThis['uri-kmp-uri'] === 'undefined' ? {} : globalThis['uri-kmp-uri'], globalThis['kotlin-kotlin-stdlib']);
  }
}(function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.q;
  var charArrayOf = kotlin_kotlin.$_$.hf;
  var concatToString = kotlin_kotlin.$_$.lj;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var AbstractList = kotlin_kotlin.$_$.q6;
  var IndexOutOfBoundsException_init_$Create$ = kotlin_kotlin.$_$.a6;
  var toString = kotlin_kotlin.$_$.hh;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var RandomAccess = kotlin_kotlin.$_$.m7;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var VOID = kotlin_kotlin.$_$.d;
  var throwUninitializedPropertyAccessException = kotlin_kotlin.$_$.ce;
  var arrayCopy = kotlin_kotlin.$_$.q7;
  var Companion_instance = kotlin_kotlin.$_$.j3;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.z;
  var createFailure = kotlin_kotlin.$_$.ko;
  var _Result___get_value__impl__bjfvqg = kotlin_kotlin.$_$.d1;
  var _Result___get_isFailure__impl__jpiriv = kotlin_kotlin.$_$.b1;
  var compareTo = kotlin_kotlin.$_$.nf;
  var Comparable = kotlin_kotlin.$_$.an;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var KProperty1 = kotlin_kotlin.$_$.yi;
  var getPropertyCallableRef = kotlin_kotlin.$_$.zf;
  var constructCallableReference = kotlin_kotlin.$_$.of;
  var Char = kotlin_kotlin.$_$.ym;
  var indexOf = kotlin_kotlin.$_$.ck;
  var lazy = kotlin_kotlin.$_$.to;
  var decodeToString = kotlin_kotlin.$_$.qj;
  var toString_0 = kotlin_kotlin.$_$.y;
  var charCodeAt = kotlin_kotlin.$_$.jf;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.x;
  var Char__rangeTo_impl_tkncvp = kotlin_kotlin.$_$.w;
  var setOf = kotlin_kotlin.$_$.sb;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.w4;
  var substring = kotlin_kotlin.$_$.pl;
  var encodeToByteArray = kotlin_kotlin.$_$.tj;
  var AssertionError_init_$Create$ = kotlin_kotlin.$_$.y4;
  var Exception = kotlin_kotlin.$_$.gn;
  var decodeToString_0 = kotlin_kotlin.$_$.pj;
  var StringBuilder_init_$Create$_0 = kotlin_kotlin.$_$.v4;
  var IllegalArgumentException_init_$Create$_0 = kotlin_kotlin.$_$.l5;
  var toByte = kotlin_kotlin.$_$.fh;
  var Exception_init_$Init$ = kotlin_kotlin.$_$.h5;
  var captureStack = kotlin_kotlin.$_$.gf;
  var defineProp = kotlin_kotlin.$_$.pf;
  var charSequenceLength = kotlin_kotlin.$_$.lf;
  var substring_0 = kotlin_kotlin.$_$.ol;
  var last = kotlin_kotlin.$_$.na;
  var lastIndexOf = kotlin_kotlin.$_$.mk;
  var toInt = kotlin_kotlin.$_$.yl;
  var NumberFormatException = kotlin_kotlin.$_$.on;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var isInterface = kotlin_kotlin.$_$.rg;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  //endregion
  //region block: pre-declaration
  initMetadataForObject(NotCachedHolder, 'NotCachedHolder');
  initMetadataForCompanion(Companion);
  initMetadataForClass(PathSegments, 'PathSegments', VOID, AbstractList, [RandomAccess]);
  initMetadataForClass(PathSegmentsBuilder, 'PathSegmentsBuilder', PathSegmentsBuilder);
  initMetadataForCompanion(Companion_0);
  function compareTo_0(other) {
    return compareTo(toString(this), toString(other));
  }
  initMetadataForInterface(Uri, 'Uri', VOID, VOID, [Comparable]);
  initMetadataForClass(ByteBuffer, 'ByteBuffer');
  initMetadataForObject(UriCodec, 'UriCodec');
  initMetadataForClass(UriSyntaxException, 'UriSyntaxException', VOID, Exception);
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(AbstractPart, 'AbstractPart');
  initMetadataForClass(Part, 'Part', VOID, AbstractPart);
  initMetadataForClass(EmptyPart, 'EmptyPart', VOID, Part);
  initMetadataForCompanion(Companion_2);
  initMetadataForCompanion(Companion_3);
  initMetadataForClass(PathPart, 'PathPart', VOID, AbstractPart);
  initMetadataForClass(AbstractHierarchicalUri, 'AbstractHierarchicalUri', VOID, VOID, [Uri]);
  initMetadataForClass(HierarchicalUri, 'HierarchicalUri', VOID, AbstractHierarchicalUri);
  initMetadataForCompanion(Companion_4);
  initMetadataForClass(StringUri, 'StringUri', VOID, AbstractHierarchicalUri);
  //endregion
  function NotCachedHolder() {
    NotCachedHolder_instance = this;
    var tmp = this;
    // Inline function 'kotlin.charArrayOf' call
    var tmp$ret$0 = charArrayOf([_Char___init__impl__6a9atx(78), _Char___init__impl__6a9atx(79), _Char___init__impl__6a9atx(84), _Char___init__impl__6a9atx(32), _Char___init__impl__6a9atx(67), _Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(67), _Char___init__impl__6a9atx(72), _Char___init__impl__6a9atx(69), _Char___init__impl__6a9atx(68)]);
    tmp.qxv_1 = concatToString(tmp$ret$0);
  }
  var NotCachedHolder_instance;
  function NotCachedHolder_getInstance() {
    if (NotCachedHolder_instance == null)
      new NotCachedHolder();
    return NotCachedHolder_instance;
  }
  function Companion() {
    Companion_instance_0 = this;
    this.rxv_1 = new PathSegments(null, 0);
  }
  var Companion_instance_0;
  function Companion_getInstance() {
    if (Companion_instance_0 == null)
      new Companion();
    return Companion_instance_0;
  }
  function PathSegments(segments, size) {
    Companion_getInstance();
    AbstractList.call(this);
    this.sxv_1 = segments;
    this.txv_1 = size;
  }
  protoOf(PathSegments).n1 = function () {
    return this.txv_1;
  };
  protoOf(PathSegments).l1 = function (index) {
    if (index >= this.txv_1) {
      throw IndexOutOfBoundsException_init_$Create$('Index ' + index + ' should be less than ' + this.txv_1);
    }
    // Inline function 'kotlin.requireNotNull' call
    var tmp0 = this.sxv_1;
    $l$block: {
      // Inline function 'kotlin.requireNotNull' call
      if (tmp0 == null) {
        var message = 'Required value was null.';
        throw IllegalArgumentException_init_$Create$(toString(message));
      } else {
        break $l$block;
      }
    }
    return this.sxv_1[index];
  };
  function _get_segments__2ewn9x($this) {
    var tmp = $this.uxv_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('segments');
    }
  }
  function PathSegmentsBuilder() {
    this.vxv_1 = 0;
  }
  protoOf(PathSegmentsBuilder).wxv = function (segment) {
    if (!(this.uxv_1 == null)) {
      if ((this.vxv_1 + 1 | 0) === _get_segments__2ewn9x(this).length) {
        var tmp = 0;
        var tmp_0 = imul(_get_segments__2ewn9x(this).length, 2);
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_1 = Array(tmp_0);
        while (tmp < tmp_0) {
          tmp_1[tmp] = '';
          tmp = tmp + 1 | 0;
        }
        var expanded = tmp_1;
        // Inline function 'kotlin.collections.copyInto' call
        var this_0 = _get_segments__2ewn9x(this);
        var endIndex = this_0.length;
        arrayCopy(this_0, expanded, 0, 0, endIndex);
        this.uxv_1 = expanded;
      }
    } else {
      var tmp_2 = this;
      var tmp_3 = 0;
      // Inline function 'kotlin.arrayOfNulls' call
      var tmp_4 = Array(4);
      while (tmp_3 < 4) {
        tmp_4[tmp_3] = '';
        tmp_3 = tmp_3 + 1 | 0;
      }
      tmp_2.uxv_1 = tmp_4;
    }
    var tmp_5 = _get_segments__2ewn9x(this);
    var tmp1 = this.vxv_1;
    this.vxv_1 = tmp1 + 1 | 0;
    tmp_5[tmp1] = segment;
  };
  protoOf(PathSegmentsBuilder).g3d = function () {
    return !(this.uxv_1 == null) ? new PathSegments(_get_segments__2ewn9x(this), this.vxv_1) : Companion_getInstance().rxv_1;
  };
  function Companion_0() {
    Companion_instance_1 = this;
    this.xxv_1 = "This isn't a hierarchical URI.";
    this.yxv_1 = new HierarchicalUri(null, Companion_getInstance_2().zxv_1, Companion_getInstance_3().cxw_1, Companion_getInstance_2().zxv_1, Companion_getInstance_2().zxv_1);
  }
  protoOf(Companion_0).dxw = function (uriString) {
    // Inline function 'kotlin.runCatching' call
    var tmp;
    try {
      // Inline function 'kotlin.Companion.success' call
      var value = new StringUri(uriString);
      tmp = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    // Inline function 'kotlin.Result.getOrNull' call
    var this_0 = tmp;
    return _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  };
  var Companion_instance_1;
  function Companion_getInstance_0() {
    if (Companion_instance_1 == null)
      new Companion_0();
    return Companion_instance_1;
  }
  function Uri() {
  }
  function _get_buffer__tgqkad($this) {
    var tmp0 = $this.jxw_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('buffer', 1, tmp, UriCodec$ByteBuffer$_get_buffer_$ref_38rov8(), null);
    return tmp0.u1();
  }
  function UriCodec$ByteBuffer$buffer$delegate$lambda(this$0) {
    return function () {
      var tmp = 0;
      var tmp_0 = this$0.ixw_1;
      var tmp_1 = new Int8Array(tmp_0);
      while (tmp < tmp_0) {
        tmp_1[tmp] = 0;
        tmp = tmp + 1 | 0;
      }
      return tmp_1;
    };
  }
  function UriCodec$ByteBuffer$_get_buffer_$ref_38rov8() {
    return constructCallableReference(function (p0) {
      return _get_buffer__tgqkad(p0);
    }, 1, 0, 532);
  }
  function isAllowed($this, c, allow) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    var progression = $this.lxw_1;
    var containsLower = progression.rm_1;
    if (c <= progression.sm_1 ? containsLower <= c : false) {
      tmp_2 = true;
    } else {
      var progression_0 = $this.nxw_1;
      var containsLower_0 = progression_0.rm_1;
      tmp_2 = c <= progression_0.sm_1 ? containsLower_0 <= c : false;
    }
    if (tmp_2) {
      tmp_1 = true;
    } else {
      var progression_1 = $this.pxw_1;
      var containsLower_1 = progression_1.rm_1;
      tmp_1 = c <= progression_1.sm_1 ? containsLower_1 <= c : false;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = $this.qxw_1.m1(new Char(c));
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = (!(allow == null) && !(indexOf(allow, c) === -1));
    }
    return tmp;
  }
  function ByteBuffer(size) {
    this.ixw_1 = size;
    var tmp = this;
    tmp.jxw_1 = lazy(UriCodec$ByteBuffer$buffer$delegate$lambda(this));
    this.kxw_1 = 0;
  }
  protoOf(ByteBuffer).cs9 = function (byte) {
    var tmp = _get_buffer__tgqkad(this);
    var tmp1 = this.kxw_1;
    this.kxw_1 = tmp1 + 1 | 0;
    tmp[tmp1] = byte;
  };
  protoOf(ByteBuffer).txw = function () {
    var tmp;
    try {
      tmp = decodeToString(_get_buffer__tgqkad(this), 0, this.kxw_1, false);
    }finally {
      this.kxw_1 = 0;
    }
    return tmp;
  };
  function unexpectedCharacterException($this, uri, name, unexpected, index) {
    var nameString = name == null ? '' : ' in [' + name + ']';
    return new UriSyntaxException(uri, 'Unexpected character' + nameString + ': ' + toString_0(unexpected), index);
  }
  function getNextCharacter($this, uri, index, end, name) {
    if (index >= end) {
      var nameString = name == null ? '' : ' in [' + name + ']';
      throw new UriSyntaxException(uri, 'Unexpected end of string ' + nameString, index);
    }
    return charCodeAt(uri, index);
  }
  function hexCharToValue($this, c) {
    var tmp;
    var progression = $this.pxw_1;
    var containsLower = progression.rm_1;
    if (c <= progression.sm_1 ? containsLower <= c : false) {
      // Inline function 'kotlin.code' call
      var tmp_0 = Char__toInt_impl_vasixd(c);
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(48);
      tmp = tmp_0 - Char__toInt_impl_vasixd(this_0) | 0;
    } else {
      var progression_0 = $this.mxw_1;
      var containsLower_0 = progression_0.rm_1;
      if (c <= progression_0.sm_1 ? containsLower_0 <= c : false) {
        // Inline function 'kotlin.code' call
        var tmp_1 = 10 + Char__toInt_impl_vasixd(c) | 0;
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(97);
        tmp = tmp_1 - Char__toInt_impl_vasixd(this_1) | 0;
      } else {
        var progression_1 = $this.oxw_1;
        var containsLower_1 = progression_1.rm_1;
        if (c <= progression_1.sm_1 ? containsLower_1 <= c : false) {
          // Inline function 'kotlin.code' call
          var tmp_2 = 10 + Char__toInt_impl_vasixd(c) | 0;
          // Inline function 'kotlin.code' call
          var this_2 = _Char___init__impl__6a9atx(65);
          tmp = tmp_2 - Char__toInt_impl_vasixd(this_2) | 0;
        } else {
          tmp = -1;
        }
      }
    }
    return tmp;
  }
  function UriCodec() {
    UriCodec_instance = this;
    this.lxw_1 = Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(122));
    this.mxw_1 = Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(97), _Char___init__impl__6a9atx(102));
    this.nxw_1 = Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(90));
    this.oxw_1 = Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(70));
    this.pxw_1 = Char__rangeTo_impl_tkncvp(_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(57));
    this.qxw_1 = setOf([new Char(_Char___init__impl__6a9atx(95)), new Char(_Char___init__impl__6a9atx(45)), new Char(_Char___init__impl__6a9atx(33)), new Char(_Char___init__impl__6a9atx(46)), new Char(_Char___init__impl__6a9atx(126)), new Char(_Char___init__impl__6a9atx(39)), new Char(_Char___init__impl__6a9atx(40)), new Char(_Char___init__impl__6a9atx(41)), new Char(_Char___init__impl__6a9atx(42))]);
    var tmp = this;
    // Inline function 'kotlin.charArrayOf' call
    tmp.rxw_1 = charArrayOf([_Char___init__impl__6a9atx(48), _Char___init__impl__6a9atx(49), _Char___init__impl__6a9atx(50), _Char___init__impl__6a9atx(51), _Char___init__impl__6a9atx(52), _Char___init__impl__6a9atx(53), _Char___init__impl__6a9atx(54), _Char___init__impl__6a9atx(55), _Char___init__impl__6a9atx(56), _Char___init__impl__6a9atx(57), _Char___init__impl__6a9atx(65), _Char___init__impl__6a9atx(66), _Char___init__impl__6a9atx(67), _Char___init__impl__6a9atx(68), _Char___init__impl__6a9atx(69), _Char___init__impl__6a9atx(70)]);
    this.sxw_1 = _Char___init__impl__6a9atx(65533);
  }
  protoOf(UriCodec).uxw = function (s) {
    return s == null ? null : this.vxw(s, null);
  };
  protoOf(UriCodec).wxw = function (s, allow) {
    return s == null ? null : this.vxw(s, allow);
  };
  protoOf(UriCodec).vxw = function (s, allow) {
    var encoded = null;
    var oldLength = s.length;
    var current = 0;
    while (current < oldLength) {
      var nextToEncode = current;
      while (nextToEncode < oldLength && isAllowed(this, charCodeAt(s, nextToEncode), allow)) {
        nextToEncode = nextToEncode + 1 | 0;
      }
      if (nextToEncode === oldLength) {
        var tmp;
        if (current === 0) {
          tmp = s;
        } else {
          ensureNotNull(encoded).bd(s, current, oldLength);
          tmp = encoded.toString();
        }
        return tmp;
      }
      if (encoded == null) {
        encoded = StringBuilder_init_$Create$();
      }
      if (nextToEncode > current) {
        encoded.bd(s, current, nextToEncode);
      }
      current = nextToEncode;
      var nextAllowed = current + 1 | 0;
      while (nextAllowed < oldLength && !isAllowed(this, charCodeAt(s, nextAllowed), allow)) {
        nextAllowed = nextAllowed + 1 | 0;
      }
      var toEncode = substring(s, current, nextAllowed);
      try {
        var bytes = encodeToByteArray(toEncode);
        var bytesLength = bytes.length;
        var inductionVariable = 0;
        if (inductionVariable < bytesLength)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoded.s(_Char___init__impl__6a9atx(37));
            encoded.s(this.rxw_1[(bytes[i] & 240) >> 4]);
            encoded.s(this.rxw_1[bytes[i] & 15]);
          }
           while (inductionVariable < bytesLength);
      } catch ($p) {
        if ($p instanceof Exception) {
          var e = $p;
          throw AssertionError_init_$Create$(e);
        } else {
          throw $p;
        }
      }
      current = nextAllowed;
    }
    decodeToString_0(new Int8Array(0));
    var tmp3_safe_receiver = encoded;
    var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.toString();
    return tmp4_elvis_lhs == null ? s : tmp4_elvis_lhs;
  };
  protoOf(UriCodec).xxw = function (s, convertPlus, throwOnFailure) {
    return s == null ? null : this.yxw(s, convertPlus, throwOnFailure);
  };
  protoOf(UriCodec).zxw = function (s, convertPlus, throwOnFailure, $super) {
    convertPlus = convertPlus === VOID ? false : convertPlus;
    throwOnFailure = throwOnFailure === VOID ? false : throwOnFailure;
    return $super === VOID ? this.xxw(s, convertPlus, throwOnFailure) : $super.xxw.call(this, s, convertPlus, throwOnFailure);
  };
  protoOf(UriCodec).yxw = function (s, convertPlus, throwOnFailure) {
    var builder = StringBuilder_init_$Create$_0(s.length);
    // Inline function 'kotlin.apply' call
    var this_0 = new ByteBuffer(s.length);
    var i = 0;
    while (i < s.length) {
      var tmp0 = i;
      i = tmp0 + 1 | 0;
      var c = charCodeAt(s, tmp0);
      if (c === _Char___init__impl__6a9atx(43)) {
        UriCodec_getInstance();
        $l$block: {
          // Inline function 'com.eygraber.uri.UriCodec.flushDecodingByteAccumulator' call
          if (this_0.kxw_1 === 0) {
            break $l$block;
          }
          try {
            builder.q(this_0.txw());
          } catch ($p) {
            if ($p instanceof Exception) {
              var e = $p;
              if (throwOnFailure) {
                throw IllegalArgumentException_init_$Create$_0(e);
              } else {
                builder.s(_Char___init__impl__6a9atx(65533));
              }
            } else {
              throw $p;
            }
          }
        }
        builder.s(convertPlus ? _Char___init__impl__6a9atx(32) : _Char___init__impl__6a9atx(43));
      } else if (c === _Char___init__impl__6a9atx(37)) {
        var hexValue = 0;
        var inductionVariable = 0;
        if (inductionVariable <= 1)
          $l$loop: do {
            var j = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp;
            try {
              tmp = getNextCharacter(UriCodec_getInstance(), s, i, s.length, null);
            } catch ($p_0) {
              var tmp_0;
              if ($p_0 instanceof UriSyntaxException) {
                var e_0 = $p_0;
                var tmp_1;
                if (throwOnFailure) {
                  throw IllegalArgumentException_init_$Create$_0(e_0);
                } else {
                  UriCodec_getInstance();
                  $l$block_0: {
                    // Inline function 'com.eygraber.uri.UriCodec.flushDecodingByteAccumulator' call
                    if (this_0.kxw_1 === 0) {
                      break $l$block_0;
                    }
                    try {
                      builder.q(this_0.txw());
                    } catch ($p_1) {
                      if ($p_1 instanceof Exception) {
                        var e_1 = $p_1;
                        if (throwOnFailure) {
                          throw IllegalArgumentException_init_$Create$_0(e_1);
                        } else {
                          builder.s(_Char___init__impl__6a9atx(65533));
                        }
                      } else {
                        throw $p_1;
                      }
                    }
                  }
                  builder.s(_Char___init__impl__6a9atx(65533));
                  return builder.toString();
                }
              } else {
                throw $p_0;
              }
            }
            var nextC = tmp;
            i = i + 1 | 0;
            var newDigit = hexCharToValue(UriCodec_getInstance(), nextC);
            if (newDigit < 0) {
              if (throwOnFailure) {
                throw IllegalArgumentException_init_$Create$_0(unexpectedCharacterException(UriCodec_getInstance(), s, null, nextC, i - 1 | 0));
              } else {
                UriCodec_getInstance();
                $l$block_1: {
                  // Inline function 'com.eygraber.uri.UriCodec.flushDecodingByteAccumulator' call
                  if (this_0.kxw_1 === 0) {
                    break $l$block_1;
                  }
                  try {
                    builder.q(this_0.txw());
                  } catch ($p_2) {
                    if ($p_2 instanceof Exception) {
                      var e_2 = $p_2;
                      if (throwOnFailure) {
                        throw IllegalArgumentException_init_$Create$_0(e_2);
                      } else {
                        builder.s(_Char___init__impl__6a9atx(65533));
                      }
                    } else {
                      throw $p_2;
                    }
                  }
                }
                builder.s(_Char___init__impl__6a9atx(65533));
                break $l$loop;
              }
            }
            hexValue = toByte((hexValue * 16 | 0) + newDigit | 0);
          }
           while (inductionVariable <= 1);
        this_0.cs9(hexValue);
      } else {
        UriCodec_getInstance();
        $l$block_2: {
          // Inline function 'com.eygraber.uri.UriCodec.flushDecodingByteAccumulator' call
          if (this_0.kxw_1 === 0) {
            break $l$block_2;
          }
          try {
            builder.q(this_0.txw());
          } catch ($p_3) {
            if ($p_3 instanceof Exception) {
              var e_3 = $p_3;
              if (throwOnFailure) {
                throw IllegalArgumentException_init_$Create$_0(e_3);
              } else {
                builder.s(_Char___init__impl__6a9atx(65533));
              }
            } else {
              throw $p_3;
            }
          }
        }
        builder.s(c);
      }
    }
    UriCodec_getInstance();
    $l$block_3: {
      // Inline function 'com.eygraber.uri.UriCodec.flushDecodingByteAccumulator' call
      if (this_0.kxw_1 === 0) {
        break $l$block_3;
      }
      try {
        builder.q(this_0.txw());
      } catch ($p_4) {
        if ($p_4 instanceof Exception) {
          var e_4 = $p_4;
          if (throwOnFailure) {
            throw IllegalArgumentException_init_$Create$_0(e_4);
          } else {
            builder.s(_Char___init__impl__6a9atx(65533));
          }
        } else {
          throw $p_4;
        }
      }
    }
    return builder.toString();
  };
  protoOf(UriCodec).axx = function (s, convertPlus, throwOnFailure, $super) {
    convertPlus = convertPlus === VOID ? false : convertPlus;
    throwOnFailure = throwOnFailure === VOID ? false : throwOnFailure;
    return $super === VOID ? this.yxw(s, convertPlus, throwOnFailure) : $super.yxw.call(this, s, convertPlus, throwOnFailure);
  };
  var UriCodec_instance;
  function UriCodec_getInstance() {
    if (UriCodec_instance == null)
      new UriCodec();
    return UriCodec_instance;
  }
  function UriSyntaxException(input, internalReason, index) {
    index = index === VOID ? -1 : index;
    Exception_init_$Init$(internalReason, this);
    captureStack(this, UriSyntaxException);
    this.bxx_1 = input;
    this.cxx_1 = internalReason;
    this.dxx_1 = index;
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!(this.dxx_1 >= -1)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    delete this.message;
  }
  protoOf(UriSyntaxException).e = function () {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    this_0.q(this.cxx_1);
    if (this.dxx_1 > -1) {
      this_0.q(' at index ');
      this_0.ed(this.dxx_1);
    }
    this_0.q(': ');
    this_0.q(this.bxx_1);
    return this_0.toString();
  };
  function _get_internalDecoded__fpdua0($this) {
    var tmp0 = $this.gxx_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('internalDecoded', 1, tmp, AbstractPart$_get_internalDecoded_$ref_ws25so(), null);
    return tmp0.u1();
  }
  function _get_internalEncoded__35l2u8($this) {
    var tmp0 = $this.hxx_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('internalEncoded', 1, tmp, AbstractPart$_get_internalEncoded_$ref_jgh4ao(), null);
    return tmp0.u1();
  }
  function Companion_1() {
    this.ixx_1 = 1;
    this.jxx_1 = 2;
  }
  var Companion_instance_2;
  function Companion_getInstance_1() {
    return Companion_instance_2;
  }
  function AbstractPart$internalDecoded$delegate$lambda(this$0, $decoded, $encoded) {
    return function () {
      var tmp;
      if (this$0.exx_1 || $decoded === NotCachedHolder_getInstance().qxv_1) {
        tmp = UriCodec_getInstance().zxw($encoded);
      } else {
        tmp = $decoded;
      }
      return tmp;
    };
  }
  function AbstractPart$_get_internalDecoded_$ref_ws25so() {
    return constructCallableReference(function (p0) {
      return _get_internalDecoded__fpdua0(p0);
    }, 1, 0, 533);
  }
  function AbstractPart$internalEncoded$delegate$lambda($encoded, this$0, $decoded) {
    return function () {
      return $encoded === NotCachedHolder_getInstance().qxv_1 ? this$0.kxx($decoded) : $encoded;
    };
  }
  function AbstractPart$_get_internalEncoded_$ref_jgh4ao() {
    return constructCallableReference(function (p0) {
      return _get_internalEncoded__35l2u8(p0);
    }, 1, 0, 534);
  }
  function AbstractPart(encoded, decoded) {
    this.exx_1 = !(encoded === NotCachedHolder_getInstance().qxv_1);
    this.fxx_1 = !(decoded === NotCachedHolder_getInstance().qxv_1);
    var tmp = this;
    tmp.gxx_1 = lazy(AbstractPart$internalDecoded$delegate$lambda(this, decoded, encoded));
    var tmp_0 = this;
    tmp_0.hxx_1 = lazy(AbstractPart$internalEncoded$delegate$lambda(encoded, this, decoded));
    if (encoded === NotCachedHolder_getInstance().qxv_1)
      if (decoded === NotCachedHolder_getInstance().qxv_1)
        throw IllegalArgumentException_init_$Create$('Neither encoded nor decoded');
  }
  protoOf(AbstractPart).lxx = function () {
    return _get_internalDecoded__fpdua0(this);
  };
  protoOf(AbstractPart).mxx = function () {
    return _get_internalEncoded__35l2u8(this);
  };
  function EmptyPart(value) {
    Part.call(this, value, value);
    // Inline function 'kotlin.text.isNullOrEmpty' call
    // Inline function 'kotlin.require' call
    if (!(value == null || charSequenceLength(value) === 0)) {
      var message = 'Expected empty value, got: ' + value;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    this.rxx_1 = true;
  }
  protoOf(EmptyPart).oy = function () {
    return this.rxx_1;
  };
  function Companion_2() {
    Companion_instance_3 = this;
    this.zxv_1 = new EmptyPart(null);
    this.axw_1 = new EmptyPart('');
  }
  protoOf(Companion_2).wxx = function (part) {
    return part == null ? this.zxv_1 : part;
  };
  protoOf(Companion_2).xxx = function (encoded) {
    return this.yxx(encoded, NotCachedHolder_getInstance().qxv_1);
  };
  protoOf(Companion_2).yxx = function (encoded, decoded) {
    var tmp;
    if (encoded == null) {
      tmp = this.zxv_1;
    } else {
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(encoded) === 0) {
        tmp = this.axw_1;
      } else {
        if (decoded == null) {
          tmp = this.zxv_1;
        } else {
          // Inline function 'kotlin.text.isEmpty' call
          if (charSequenceLength(decoded) === 0) {
            tmp = this.axw_1;
          } else {
            tmp = new Part(encoded, decoded);
          }
        }
      }
    }
    return tmp;
  };
  var Companion_instance_3;
  function Companion_getInstance_2() {
    if (Companion_instance_3 == null)
      new Companion_2();
    return Companion_instance_3;
  }
  function Part(encoded, decoded) {
    Companion_getInstance_2();
    AbstractPart.call(this, encoded, decoded);
  }
  protoOf(Part).oy = function () {
    return false;
  };
  protoOf(Part).kxx = function (decoded) {
    return UriCodec_getInstance().uxw(decoded);
  };
  function Companion_3() {
    Companion_instance_4 = this;
    this.bxw_1 = new PathPart(null, null);
    this.cxw_1 = new PathPart('', '');
  }
  protoOf(Companion_3).xxx = function (encoded) {
    return this.yxx(encoded, NotCachedHolder_getInstance().qxv_1);
  };
  protoOf(Companion_3).yxx = function (encoded, decoded) {
    if (encoded == null) {
      return this.bxw_1;
    }
    var tmp;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(encoded) === 0) {
      tmp = this.cxw_1;
    } else {
      tmp = new PathPart(encoded, decoded);
    }
    return tmp;
  };
  var Companion_instance_4;
  function Companion_getInstance_3() {
    if (Companion_instance_4 == null)
      new Companion_3();
    return Companion_instance_4;
  }
  function PathPart$pathSegments$delegate$lambda($encoded) {
    return function () {
      var tmp0_elvis_lhs = $encoded;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return Companion_getInstance().rxv_1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var path = tmp;
      var segmentBuilder = new PathSegmentsBuilder();
      var previous = 0;
      var current;
      $l$loop: while (true) {
        // Inline function 'kotlin.also' call
        var this_0 = indexOf(path, _Char___init__impl__6a9atx(47), previous);
        current = this_0;
        if (!(this_0 > -1)) {
          break $l$loop;
        }
        if (previous < current) {
          segmentBuilder.wxv(UriCodec_getInstance().axx(substring(path, previous, current)));
        }
        previous = current + 1 | 0;
      }
      var tmp_0;
      if (previous < path.length) {
        segmentBuilder.wxv(UriCodec_getInstance().axx(substring_0(path, previous)));
        tmp_0 = Unit_instance;
      }
      return segmentBuilder.g3d();
    };
  }
  function PathPart$_get_pathSegments_$ref_udpq67() {
    return constructCallableReference(function (p0) {
      return p0.dt7();
    }, 1, 0, 535);
  }
  function PathPart(encoded, decoded) {
    Companion_getInstance_3();
    AbstractPart.call(this, encoded, decoded);
    var tmp = this;
    tmp.dxy_1 = lazy(PathPart$pathSegments$delegate$lambda(encoded));
  }
  protoOf(PathPart).kxx = function (decoded) {
    return UriCodec_getInstance().wxw(decoded, '/');
  };
  protoOf(PathPart).dt7 = function () {
    var tmp0 = this.dxy_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('pathSegments', 1, tmp, PathPart$_get_pathSegments_$ref_udpq67(), null);
    return tmp0.u1();
  };
  function _get__userInfo__u1z7bt($this) {
    var tmp0 = $this.fxy_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('_userInfo', 1, tmp, AbstractHierarchicalUri$_get__userInfo_$ref_hwsvc5(), null);
    return tmp0.u1();
  }
  function findPortSeparator($this, authority) {
    var inductionVariable = authority.length - 1 | 0;
    if (0 <= inductionVariable)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + -1 | 0;
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(authority, i);
        var character = Char__toInt_impl_vasixd(this_0);
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(58);
        if (Char__toInt_impl_vasixd(this_1) === character)
          return i;
        var tmp;
        // Inline function 'kotlin.code' call
        var this_2 = _Char___init__impl__6a9atx(48);
        if (character < Char__toInt_impl_vasixd(this_2)) {
          tmp = true;
        } else {
          // Inline function 'kotlin.code' call
          var this_3 = _Char___init__impl__6a9atx(57);
          tmp = character > Char__toInt_impl_vasixd(this_3);
        }
        if (tmp)
          return -1;
      }
       while (0 <= inductionVariable);
    return -1;
  }
  function AbstractHierarchicalUri$lastPathSegment$delegate$lambda(this$0) {
    return function () {
      var segments = this$0.dt7();
      return segments.r() ? null : last(segments);
    };
  }
  function AbstractHierarchicalUri$_userInfo$delegate$lambda(this$0) {
    return function () {
      var tmp0_elvis_lhs = this$0.fxw();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return Companion_getInstance_2().xxx(null);
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var authority = tmp;
      var end = lastIndexOf(authority, _Char___init__impl__6a9atx(64));
      return Companion_getInstance_2().xxx(end === -1 ? null : substring(authority, 0, end));
    };
  }
  function AbstractHierarchicalUri$_get__userInfo_$ref_hwsvc5() {
    return constructCallableReference(function (p0) {
      return _get__userInfo__u1z7bt(p0);
    }, 1, 0, 536);
  }
  function AbstractHierarchicalUri$userInfo$delegate$lambda(this$0) {
    return function () {
      return _get__userInfo__u1z7bt(this$0).lxx();
    };
  }
  function AbstractHierarchicalUri$encodedUserInfo$delegate$lambda(this$0) {
    return function () {
      return _get__userInfo__u1z7bt(this$0).mxx();
    };
  }
  function AbstractHierarchicalUri$host$delegate$lambda(this$0) {
    return function () {
      var tmp0_elvis_lhs = this$0.fxw();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return null;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var authority = tmp;
      var userInfoSeparator = lastIndexOf(authority, _Char___init__impl__6a9atx(64));
      var portSeparator = findPortSeparator(this$0, authority);
      var encodedHost = portSeparator === -1 ? substring_0(authority, userInfoSeparator + 1 | 0) : substring(authority, userInfoSeparator + 1 | 0, portSeparator);
      return UriCodec_getInstance().axx(encodedHost);
    };
  }
  function AbstractHierarchicalUri$port$delegate$lambda(this$0) {
    return function () {
      var tmp0_elvis_lhs = this$0.fxw();
      var tmp;
      if (tmp0_elvis_lhs == null) {
        return -1;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var authority = tmp;
      var portSeparator = findPortSeparator(this$0, authority);
      var tmp_0;
      if (portSeparator === -1) {
        return -1;
      }
      var portString = UriCodec_getInstance().axx(substring_0(authority, portSeparator + 1 | 0));
      var tmp_1;
      try {
        tmp_1 = toInt(portString);
      } catch ($p) {
        var tmp_2;
        if ($p instanceof NumberFormatException) {
          var e = $p;
          tmp_2 = -1;
        } else {
          throw $p;
        }
        tmp_1 = tmp_2;
      }
      return tmp_1;
    };
  }
  function AbstractHierarchicalUri() {
    var tmp = this;
    tmp.exy_1 = lazy(AbstractHierarchicalUri$lastPathSegment$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.fxy_1 = lazy(AbstractHierarchicalUri$_userInfo$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.gxy_1 = lazy(AbstractHierarchicalUri$userInfo$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.hxy_1 = lazy(AbstractHierarchicalUri$encodedUserInfo$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.ixy_1 = lazy(AbstractHierarchicalUri$host$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.jxy_1 = lazy(AbstractHierarchicalUri$port$delegate$lambda(this));
  }
  protoOf(AbstractHierarchicalUri).d = function (other) {
    return this.hxw((!(other == null) ? isInterface(other, Uri) : false) ? other : THROW_CCE());
  };
  function _get_ssp__e6gvb5($this) {
    var tmp0 = $this.xxy_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('ssp', 1, tmp, HierarchicalUri$_get_ssp_$ref_rninsh(), null);
    return tmp0.u1();
  }
  function makeSchemeSpecificPart($this) {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$();
    appendSspTo($this, this_0);
    return this_0.toString();
  }
  function appendSspTo($this, $receiver) {
    var encodedAuthority = $this.rxy_1.mxx();
    if (!(encodedAuthority == null)) {
      $receiver.q('//').q(encodedAuthority);
    }
    var encodedPath = $this.sxy_1.mxx();
    if (!(encodedPath == null)) {
      $receiver.q(encodedPath);
    }
    if (!$this.txy_1.oy()) {
      $receiver.s(_Char___init__impl__6a9atx(63)).q($this.txy_1.mxx());
    }
  }
  function _get_uriString__5epoks($this) {
    var tmp0 = $this.jxz_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('uriString', 1, tmp, HierarchicalUri$_get_uriString_$ref_1s3xem(), null);
    return tmp0.u1();
  }
  function HierarchicalUri$ssp$delegate$lambda(this$0) {
    return function () {
      return Companion_getInstance_2().xxx(makeSchemeSpecificPart(this$0));
    };
  }
  function HierarchicalUri$_get_ssp_$ref_rninsh() {
    return constructCallableReference(function (p0) {
      return _get_ssp__e6gvb5(p0);
    }, 1, 0, 537);
  }
  function HierarchicalUri$encodedSchemeSpecificPart$delegate$lambda(this$0) {
    return function () {
      return _get_ssp__e6gvb5(this$0).mxx();
    };
  }
  function HierarchicalUri$schemeSpecificPart$delegate$lambda(this$0) {
    return function () {
      return _get_ssp__e6gvb5(this$0).lxx();
    };
  }
  function HierarchicalUri$authority$delegate$lambda(this$0) {
    return function () {
      return this$0.rxy_1.lxx();
    };
  }
  function HierarchicalUri$encodedAuthority$delegate$lambda(this$0) {
    return function () {
      return this$0.rxy_1.mxx();
    };
  }
  function HierarchicalUri$_get_encodedAuthority_$ref_xbmmkm() {
    return constructCallableReference(function (p0) {
      return p0.fxw();
    }, 1, 0, 538);
  }
  function HierarchicalUri$encodedPath$delegate$lambda(this$0) {
    return function () {
      return this$0.sxy_1.mxx();
    };
  }
  function HierarchicalUri$path$delegate$lambda(this$0) {
    return function () {
      return this$0.sxy_1.lxx();
    };
  }
  function HierarchicalUri$_get_path_$ref_3ccxi() {
    return constructCallableReference(function (p0) {
      return p0.gxw();
    }, 1, 0, 539);
  }
  function HierarchicalUri$query$delegate$lambda(this$0) {
    return function () {
      return this$0.txy_1.lxx();
    };
  }
  function HierarchicalUri$encodedQuery$delegate$lambda(this$0) {
    return function () {
      return this$0.txy_1.mxx();
    };
  }
  function HierarchicalUri$fragment$delegate$lambda(this$0) {
    return function () {
      return this$0.uxy_1.lxx();
    };
  }
  function HierarchicalUri$encodedFragment$delegate$lambda(this$0) {
    return function () {
      return this$0.uxy_1.mxx();
    };
  }
  function HierarchicalUri$_get_encodedFragment_$ref_kwrdr5() {
    return constructCallableReference(function (p0) {
      return p0.mt7();
    }, 1, 0, 540);
  }
  function HierarchicalUri$pathSegments$delegate$lambda(this$0) {
    return function () {
      return this$0.sxy_1.dt7();
    };
  }
  function HierarchicalUri$_get_pathSegments_$ref_wkjjgq() {
    return constructCallableReference(function (p0) {
      return p0.dt7();
    }, 1, 0, 541);
  }
  function HierarchicalUri$uriString$delegate$lambda(this$0) {
    return function () {
      // Inline function 'kotlin.text.buildString' call
      // Inline function 'kotlin.apply' call
      var this_0 = StringBuilder_init_$Create$();
      if (!(this$0.qxy_1 == null)) {
        this_0.q(this$0.qxy_1).s(_Char___init__impl__6a9atx(58));
      }
      appendSspTo(this$0, this_0);
      if (!this$0.uxy_1.oy()) {
        this_0.s(_Char___init__impl__6a9atx(35)).q(this$0.mt7());
      }
      return this_0.toString();
    };
  }
  function HierarchicalUri$_get_uriString_$ref_1s3xem() {
    return constructCallableReference(function (p0) {
      return _get_uriString__5epoks(p0);
    }, 1, 0, 542);
  }
  function HierarchicalUri(scheme, _authorityPart, _pathPart, _queryPart, _fragmentPart) {
    AbstractHierarchicalUri.call(this);
    this.qxy_1 = scheme;
    this.rxy_1 = Companion_getInstance_2().wxx(_authorityPart);
    var tmp = this;
    tmp.sxy_1 = _pathPart == null ? Companion_getInstance_3().bxw_1 : _pathPart;
    this.txy_1 = Companion_getInstance_2().wxx(_queryPart);
    this.uxy_1 = Companion_getInstance_2().wxx(_fragmentPart);
    this.vxy_1 = true;
    this.wxy_1 = this.qxy_1 == null;
    var tmp_0 = this;
    tmp_0.xxy_1 = lazy(HierarchicalUri$ssp$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.yxy_1 = lazy(HierarchicalUri$encodedSchemeSpecificPart$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.zxy_1 = lazy(HierarchicalUri$schemeSpecificPart$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.axz_1 = lazy(HierarchicalUri$authority$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.bxz_1 = lazy(HierarchicalUri$encodedAuthority$delegate$lambda(this));
    var tmp_5 = this;
    tmp_5.cxz_1 = lazy(HierarchicalUri$encodedPath$delegate$lambda(this));
    var tmp_6 = this;
    tmp_6.dxz_1 = lazy(HierarchicalUri$path$delegate$lambda(this));
    var tmp_7 = this;
    tmp_7.exz_1 = lazy(HierarchicalUri$query$delegate$lambda(this));
    var tmp_8 = this;
    tmp_8.fxz_1 = lazy(HierarchicalUri$encodedQuery$delegate$lambda(this));
    var tmp_9 = this;
    tmp_9.gxz_1 = lazy(HierarchicalUri$fragment$delegate$lambda(this));
    var tmp_10 = this;
    tmp_10.hxz_1 = lazy(HierarchicalUri$encodedFragment$delegate$lambda(this));
    var tmp_11 = this;
    tmp_11.ixz_1 = lazy(HierarchicalUri$pathSegments$delegate$lambda(this));
    var tmp_12 = this;
    tmp_12.jxz_1 = lazy(HierarchicalUri$uriString$delegate$lambda(this));
  }
  protoOf(HierarchicalUri).exw = function () {
    return this.qxy_1;
  };
  protoOf(HierarchicalUri).fxw = function () {
    var tmp0 = this.bxz_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('encodedAuthority', 1, tmp, HierarchicalUri$_get_encodedAuthority_$ref_xbmmkm(), null);
    return tmp0.u1();
  };
  protoOf(HierarchicalUri).gxw = function () {
    var tmp0 = this.dxz_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('path', 1, tmp, HierarchicalUri$_get_path_$ref_3ccxi(), null);
    return tmp0.u1();
  };
  protoOf(HierarchicalUri).mt7 = function () {
    var tmp0 = this.hxz_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('encodedFragment', 1, tmp, HierarchicalUri$_get_encodedFragment_$ref_kwrdr5(), null);
    return tmp0.u1();
  };
  protoOf(HierarchicalUri).dt7 = function () {
    var tmp0 = this.ixz_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('pathSegments', 1, tmp, HierarchicalUri$_get_pathSegments_$ref_wkjjgq(), null);
    return tmp0.u1();
  };
  protoOf(HierarchicalUri).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Uri) : false) {
      tmp = this.toString() === toString(other);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(HierarchicalUri).hashCode = function () {
    return getStringHashCode(this.toString());
  };
  protoOf(HierarchicalUri).toString = function () {
    return _get_uriString__5epoks(this);
  };
  protoOf(HierarchicalUri).d = function (other) {
    return this.hxw((!(other == null) ? isInterface(other, Uri) : false) ? other : THROW_CCE());
  };
  function _get_cachedSsi__l34qja($this) {
    var tmp0 = $this.rxz_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('cachedSsi', 1, tmp, StringUri$_get_cachedSsi_$ref_1wqtio(), null);
    return tmp0.u1();
  }
  function _get_cachedFsi__l3d1d5($this) {
    var tmp0 = $this.sxz_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('cachedFsi', 1, tmp, StringUri$_get_cachedFsi_$ref_hmt2eb(), null);
    return tmp0.u1();
  }
  function _get_authorityPart__2eumyj($this) {
    var tmp0 = $this.xxz_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('authorityPart', 1, tmp, StringUri$_get_authorityPart_$ref_crqh35(), null);
    return tmp0.u1();
  }
  function _get_pathPart__i0uz2r($this) {
    var tmp0 = $this.ay0_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('pathPart', 1, tmp, StringUri$_get_pathPart_$ref_qv643v(), null);
    return tmp0.u1();
  }
  function _get_queryPart__onb3u2($this) {
    var tmp0 = $this.ey0_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('queryPart', 1, tmp, StringUri$_get_queryPart_$ref_4ed0pw(), null);
    return tmp0.u1();
  }
  function _get_fragmentPart__iqsq0o($this) {
    var tmp0 = $this.hy0_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('fragmentPart', 1, tmp, StringUri$_get_fragmentPart_$ref_fv38g0(), null);
    return tmp0.u1();
  }
  function Companion_4() {
  }
  protoOf(Companion_4).ky0 = function (uriString, ssi) {
    var length = uriString.length;
    var tmp;
    if (length > (ssi + 2 | 0) && charCodeAt(uriString, ssi + 1 | 0) === _Char___init__impl__6a9atx(47) && charCodeAt(uriString, ssi + 2 | 0) === _Char___init__impl__6a9atx(47)) {
      var end = ssi + 3 | 0;
      $l$loop_0: while (end < length) {
        var c = charCodeAt(uriString, end);
        if (c === _Char___init__impl__6a9atx(47) || c === _Char___init__impl__6a9atx(92))
          break $l$loop_0;
        if (c === _Char___init__impl__6a9atx(63) || c === _Char___init__impl__6a9atx(35))
          break $l$loop_0;
        end = end + 1 | 0;
      }
      tmp = substring(uriString, ssi + 3 | 0, end);
    } else {
      tmp = null;
    }
    return tmp;
  };
  protoOf(Companion_4).ly0 = function (uriString, ssi) {
    var length = uriString.length;
    var pathStart;
    if (length > (ssi + 2 | 0) && charCodeAt(uriString, ssi + 1 | 0) === _Char___init__impl__6a9atx(47) && charCodeAt(uriString, ssi + 2 | 0) === _Char___init__impl__6a9atx(47)) {
      pathStart = ssi + 3 | 0;
      $l$loop: while (pathStart < length) {
        var c = charCodeAt(uriString, pathStart);
        if (c === _Char___init__impl__6a9atx(63) || c === _Char___init__impl__6a9atx(35))
          return '';
        if (c === _Char___init__impl__6a9atx(47) || c === _Char___init__impl__6a9atx(92))
          break $l$loop;
        pathStart = pathStart + 1 | 0;
      }
    } else {
      pathStart = ssi + 1 | 0;
    }
    var pathEnd = pathStart;
    $l$loop_0: while (pathEnd < length) {
      var c_0 = charCodeAt(uriString, pathEnd);
      if (c_0 === _Char___init__impl__6a9atx(63) || c_0 === _Char___init__impl__6a9atx(35))
        break $l$loop_0;
      pathEnd = pathEnd + 1 | 0;
    }
    return substring(uriString, pathStart, pathEnd);
  };
  var Companion_instance_5;
  function Companion_getInstance_4() {
    return Companion_instance_5;
  }
  function StringUri$cachedSsi$delegate$lambda(this$0) {
    return function () {
      return indexOf(this$0.qxz_1, _Char___init__impl__6a9atx(58));
    };
  }
  function StringUri$_get_cachedSsi_$ref_1wqtio() {
    return constructCallableReference(function (p0) {
      return _get_cachedSsi__l34qja(p0);
    }, 1, 0, 543);
  }
  function StringUri$cachedFsi$delegate$lambda(this$0) {
    return function () {
      return indexOf(this$0.qxz_1, _Char___init__impl__6a9atx(35), _get_cachedSsi__l34qja(this$0));
    };
  }
  function StringUri$_get_cachedFsi_$ref_hmt2eb() {
    return constructCallableReference(function (p0) {
      return _get_cachedFsi__l3d1d5(p0);
    }, 1, 0, 544);
  }
  function StringUri$isHierarchical$delegate$lambda(this$0) {
    return function () {
      var ssi = _get_cachedSsi__l34qja(this$0);
      var tmp;
      if (ssi === -1) {
        tmp = true;
      } else {
        tmp = this$0.qxz_1.length === (ssi + 1 | 0) ? false : charCodeAt(this$0.qxz_1, ssi + 1 | 0) === _Char___init__impl__6a9atx(47);
      }
      return tmp;
    };
  }
  function StringUri$isRelative$delegate$lambda(this$0) {
    return function () {
      return _get_cachedSsi__l34qja(this$0) === -1;
    };
  }
  function StringUri$scheme$delegate$lambda(this$0) {
    return function () {
      var ssi = _get_cachedSsi__l34qja(this$0);
      return ssi === -1 ? null : substring(this$0.qxz_1, 0, ssi);
    };
  }
  function StringUri$_get_scheme_$ref_c89ede() {
    return constructCallableReference(function (p0) {
      return p0.exw();
    }, 1, 0, 545);
  }
  function StringUri$ssp$delegate$lambda(this$0) {
    return function () {
      var ssi = _get_cachedSsi__l34qja(this$0);
      var fsi = _get_cachedFsi__l3d1d5(this$0);
      return Companion_getInstance_2().xxx(fsi === -1 ? substring_0(this$0.qxz_1, ssi + 1 | 0) : substring(this$0.qxz_1, ssi + 1 | 0, fsi));
    };
  }
  function StringUri$authorityPart$delegate$lambda(this$0) {
    return function () {
      var encodedAuthority = Companion_instance_5.ky0(this$0.qxz_1, _get_cachedSsi__l34qja(this$0));
      return Companion_getInstance_2().xxx(encodedAuthority);
    };
  }
  function StringUri$_get_authorityPart_$ref_crqh35() {
    return constructCallableReference(function (p0) {
      return _get_authorityPart__2eumyj(p0);
    }, 1, 0, 546);
  }
  function StringUri$authority$delegate$lambda(this$0) {
    return function () {
      return _get_authorityPart__2eumyj(this$0).lxx();
    };
  }
  function StringUri$encodedAuthority$delegate$lambda(this$0) {
    return function () {
      return _get_authorityPart__2eumyj(this$0).mxx();
    };
  }
  function StringUri$_get_encodedAuthority_$ref_pselou() {
    return constructCallableReference(function (p0) {
      return p0.fxw();
    }, 1, 0, 547);
  }
  function StringUri$pathPart$delegate$lambda(this$0) {
    return function () {
      var ssi = _get_cachedSsi__l34qja(this$0);
      var tmp;
      if (ssi > -1) {
        var schemeOnly = (ssi + 1 | 0) === this$0.qxz_1.length;
        tmp = schemeOnly ? null : !(charCodeAt(this$0.qxz_1, ssi + 1 | 0) === _Char___init__impl__6a9atx(47)) ? null : Companion_instance_5.ly0(this$0.qxz_1, ssi);
      } else {
        tmp = Companion_instance_5.ly0(this$0.qxz_1, ssi);
      }
      var encoded = tmp;
      return Companion_getInstance_3().xxx(encoded);
    };
  }
  function StringUri$_get_pathPart_$ref_qv643v() {
    return constructCallableReference(function (p0) {
      return _get_pathPart__i0uz2r(p0);
    }, 1, 0, 548);
  }
  function StringUri$path$delegate$lambda(this$0) {
    return function () {
      return _get_pathPart__i0uz2r(this$0).lxx();
    };
  }
  function StringUri$_get_path_$ref_iv2w3i() {
    return constructCallableReference(function (p0) {
      return p0.gxw();
    }, 1, 0, 549);
  }
  function StringUri$encodedPath$delegate$lambda(this$0) {
    return function () {
      return _get_pathPart__i0uz2r(this$0).mxx();
    };
  }
  function StringUri$pathSegments$delegate$lambda(this$0) {
    return function () {
      return _get_pathPart__i0uz2r(this$0).dt7();
    };
  }
  function StringUri$_get_pathSegments_$ref_d30khu() {
    return constructCallableReference(function (p0) {
      return p0.dt7();
    }, 1, 0, 550);
  }
  function StringUri$queryPart$delegate$lambda(this$0) {
    return function () {
      var qsi = indexOf(this$0.qxz_1, _Char___init__impl__6a9atx(63), _get_cachedSsi__l34qja(this$0));
      var tmp;
      if (qsi === -1) {
        tmp = null;
      } else {
        var fsi = _get_cachedFsi__l3d1d5(this$0);
        tmp = fsi === -1 ? substring_0(this$0.qxz_1, qsi + 1 | 0) : fsi < qsi ? null : substring(this$0.qxz_1, qsi + 1 | 0, fsi);
      }
      var encoded = tmp;
      return Companion_getInstance_2().xxx(encoded);
    };
  }
  function StringUri$_get_queryPart_$ref_4ed0pw() {
    return constructCallableReference(function (p0) {
      return _get_queryPart__onb3u2(p0);
    }, 1, 0, 551);
  }
  function StringUri$query$delegate$lambda(this$0) {
    return function () {
      return _get_queryPart__onb3u2(this$0).lxx();
    };
  }
  function StringUri$encodedQuery$delegate$lambda(this$0) {
    return function () {
      return _get_queryPart__onb3u2(this$0).mxx();
    };
  }
  function StringUri$fragmentPart$delegate$lambda(this$0) {
    return function () {
      var fsi = _get_cachedFsi__l3d1d5(this$0);
      return Companion_getInstance_2().xxx(fsi === -1 ? null : substring_0(this$0.qxz_1, fsi + 1 | 0));
    };
  }
  function StringUri$_get_fragmentPart_$ref_fv38g0() {
    return constructCallableReference(function (p0) {
      return _get_fragmentPart__iqsq0o(p0);
    }, 1, 0, 552);
  }
  function StringUri$fragment$delegate$lambda(this$0) {
    return function () {
      return _get_fragmentPart__iqsq0o(this$0).lxx();
    };
  }
  function StringUri$encodedFragment$delegate$lambda(this$0) {
    return function () {
      return _get_fragmentPart__iqsq0o(this$0).mxx();
    };
  }
  function StringUri(uriString) {
    AbstractHierarchicalUri.call(this);
    this.qxz_1 = uriString;
    var tmp = this;
    tmp.rxz_1 = lazy(StringUri$cachedSsi$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.sxz_1 = lazy(StringUri$cachedFsi$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.txz_1 = lazy(StringUri$isHierarchical$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.uxz_1 = lazy(StringUri$isRelative$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.vxz_1 = lazy(StringUri$scheme$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.wxz_1 = lazy(StringUri$ssp$delegate$lambda(this));
    var tmp_5 = this;
    tmp_5.xxz_1 = lazy(StringUri$authorityPart$delegate$lambda(this));
    var tmp_6 = this;
    tmp_6.yxz_1 = lazy(StringUri$authority$delegate$lambda(this));
    var tmp_7 = this;
    tmp_7.zxz_1 = lazy(StringUri$encodedAuthority$delegate$lambda(this));
    var tmp_8 = this;
    tmp_8.ay0_1 = lazy(StringUri$pathPart$delegate$lambda(this));
    var tmp_9 = this;
    tmp_9.by0_1 = lazy(StringUri$path$delegate$lambda(this));
    var tmp_10 = this;
    tmp_10.cy0_1 = lazy(StringUri$encodedPath$delegate$lambda(this));
    var tmp_11 = this;
    tmp_11.dy0_1 = lazy(StringUri$pathSegments$delegate$lambda(this));
    var tmp_12 = this;
    tmp_12.ey0_1 = lazy(StringUri$queryPart$delegate$lambda(this));
    var tmp_13 = this;
    tmp_13.fy0_1 = lazy(StringUri$query$delegate$lambda(this));
    var tmp_14 = this;
    tmp_14.gy0_1 = lazy(StringUri$encodedQuery$delegate$lambda(this));
    var tmp_15 = this;
    tmp_15.hy0_1 = lazy(StringUri$fragmentPart$delegate$lambda(this));
    var tmp_16 = this;
    tmp_16.iy0_1 = lazy(StringUri$fragment$delegate$lambda(this));
    var tmp_17 = this;
    tmp_17.jy0_1 = lazy(StringUri$encodedFragment$delegate$lambda(this));
  }
  protoOf(StringUri).exw = function () {
    var tmp0 = this.vxz_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('scheme', 1, tmp, StringUri$_get_scheme_$ref_c89ede(), null);
    return tmp0.u1();
  };
  protoOf(StringUri).fxw = function () {
    var tmp0 = this.zxz_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('encodedAuthority', 1, tmp, StringUri$_get_encodedAuthority_$ref_pselou(), null);
    return tmp0.u1();
  };
  protoOf(StringUri).gxw = function () {
    var tmp0 = this.by0_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('path', 1, tmp, StringUri$_get_path_$ref_iv2w3i(), null);
    return tmp0.u1();
  };
  protoOf(StringUri).dt7 = function () {
    var tmp0 = this.dy0_1;
    var tmp = KProperty1;
    // Inline function 'kotlin.getValue' call
    getPropertyCallableRef('pathSegments', 1, tmp, StringUri$_get_pathSegments_$ref_d30khu(), null);
    return tmp0.u1();
  };
  protoOf(StringUri).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, Uri) : false) {
      tmp = this.toString() === toString(other);
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(StringUri).hashCode = function () {
    return getStringHashCode(this.toString());
  };
  protoOf(StringUri).toString = function () {
    return this.qxz_1;
  };
  protoOf(StringUri).d = function (other) {
    return this.hxw((!(other == null) ? isInterface(other, Uri) : false) ? other : THROW_CCE());
  };
  //region block: post-declaration
  defineProp(protoOf(UriSyntaxException), 'message', function () {
    return this.e();
  });
  protoOf(AbstractHierarchicalUri).hxw = compareTo_0;
  //endregion
  //region block: init
  Companion_instance_2 = new Companion_1();
  Companion_instance_5 = new Companion_4();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Uri;
  _.$_$.b = Companion_getInstance_0;
  //endregion
  return _;
}));

//# sourceMappingURL=uri-kmp-uri.js.map
